import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import BeneficiaryAccordion from '../../beneficiaries/components/BeneficiaryAccordion';

/**
 * Read-only beneficiaries display for Payludd terminal state.
 * @param {object} root0 component props
 * @param {Array<object>} root0.beneficiaries beneficiaries from terminal state
 * @returns {JSX.Element|null} beneficiaries section
 */
function BeneficiaryView({ beneficiaries }) {
    const [openItems, setOpenItems] = useState([]);

    const normalizedBeneficiaries = useMemo(() => beneficiaries.map((beneficiary, beneficiaryIndex) => {
        const contracts = (beneficiary.contracts ?? []).map((contract, contractIndex) => ({
            // ContractCard expects these exact keys
            contract: contract.merchantId || '',
            rank: contract.nlsa || '',
            bankCode: contract.bankCode || '',
            application: contract.applicationType || 'CBEMV',
            // uuid is used as key in BeneficiaryAccordion
            uuid: `${beneficiary.name || 'beneficiary'}-${contract.merchantId || 'contract'}-${contractIndex}`,
            // keep raw values if needed later
            ...contract
        }));

        return {
            uuid: beneficiary.uuid || `${beneficiary.name || 'beneficiary'}-${beneficiaryIndex}`,
            name: beneficiary.name || '',
            color: beneficiary.color || '#e5e7eb',
            contracts
        };
    }), [beneficiaries]);

    useEffect(() => {
        setOpenItems(normalizedBeneficiaries.map((_, index) => `beneficiary-${index}`));
    }, [normalizedBeneficiaries]);

    return (
        normalizedBeneficiaries.length > 0 && (
            <BeneficiaryAccordion
                beneficiaries={normalizedBeneficiaries}
                openItems={openItems}
                setOpenItems={setOpenItems}
                showActions={false}
                displayVariant='tpe'
            />
        )
    );
}

BeneficiaryView.propTypes = {
    beneficiaries: PropTypes.array.isRequired
};

export default BeneficiaryView;
